export default __webpack_public_path__ + "c2aa4ab115bf9c6057cb59709d0e152b.woff2";